export class CustomSelectSorting {
  constructor() {
    this.customSelects = document.querySelectorAll(".sorting-primary");
    if (this.customSelects.length > 0) {
      this.init();
    }
  }

  init() {
    // Radio filters
    this.customSelects.forEach((customSelect) => {
      const selectBtn = customSelect.querySelector(".jet-smart-filters-radio");
      const selectedValue = customSelect.querySelector(
        ".jet-smart-filters-radio .jet-filter-label"
      );
      const optionsList = customSelect.querySelectorAll(
        ".jet-radio-list .jet-radio-list__button"
      );

      // Only proceed if we have all required elements
      if (!selectBtn || !selectedValue || !optionsList.length) {
        return;
      }

      const selectedOption = customSelect.querySelector(
        ".jet-radio-list__item input:checked"
      );
      if (selectedOption) {
        const optionLabel = selectedOption
          .closest(".jet-radio-list__item")
          .querySelector(".jet-radio-list__label");
        if (optionLabel) {
          selectedValue.textContent = optionLabel.textContent;
        }
      }

      selectBtn.addEventListener("click", () => this.toggleDropdown(selectBtn));

      optionsList.forEach((option) => {
        const optionLabel = option.querySelector(".jet-radio-list__label");
        if (optionLabel) {
          option.addEventListener("click", (e) =>
            this.handleSelection(e, optionLabel, selectedValue, selectBtn)
          );
          option.addEventListener("keyup", (e) =>
            this.handleSelection(e, optionLabel, selectedValue, selectBtn)
          );
        }
      });
    });

    // Checkboxes filter
    this.customSelects.forEach((customSelect) => {
      const selectBtn = customSelect.querySelector(
        ".jet-smart-filters-checkboxes"
      );

      const optionsList = customSelect.querySelectorAll(
        ".jet-checkboxes-list .jet-checkboxes-list__button"
      );

      // Only proceed if we have all required elements
      if (!selectBtn || !optionsList.length) {
        return;
      }

      selectBtn.addEventListener("click", () => this.toggleDropdown(selectBtn));
    });

    // Close filter if click outside
    document.addEventListener("mousedown", (e) => {
      if (this.customSelects) {
        this.customSelects.forEach((select) => {
          const radioBtn = select.querySelector(".jet-smart-filters-radio");
          const checkboxBtn = select.querySelector(
            ".jet-smart-filters-checkboxes"
          );
          if (!select.contains(e.target)) {
            if (radioBtn) radioBtn.setAttribute("aria-expanded", "false");
            if (checkboxBtn) checkboxBtn.setAttribute("aria-expanded", "false");
          }
        });
      }
    });
  }

  toggleDropdown(selectBtn) {
    const isExpanded = selectBtn.getAttribute("aria-expanded") === "true";
    selectBtn.setAttribute("aria-expanded", String(!isExpanded));
  }

  isSelected(e) {
    return (
      (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) ||
      e.key === "Enter"
    );
  }

  handleSelection(e, optionLabel, selectedValue, selectBtn) {
    if (this.isSelected(e)) {
      selectedValue.textContent = optionLabel.textContent;
      this.toggleDropdown(selectBtn);
    }
  }
}
